import React from 'react';

function MarketingRoot({ children, className = '' }) {
  const rootClassName = ['google-material-root', 'google-marketing-root', className]
    .filter(Boolean)
    .join(' ');

  return <div className={rootClassName}>{children}</div>;
}

export default MarketingRoot;
